import React, { useState, useEffect, useContext } from 'react'

// styles for page
import './styles.css'

// components for page
import api from '../../services/api';
import SmallCard from '../smallCard/index'
import NavigationBar from '../navigationBar/index'
import errorHandlerShow from '../errorHandlerShow/index.js'
import StoreContext from '../../components/storage/context'
import AlertCustom from '../../components/alertCustom/index.js'
import SmallCardPlaceholder from '../../components/placeholders/smallCardPlaceholder'

import image_default from '../../assets/diagrama_integration_layer.png'


const IntegrationLayerHome = () => {
    const { pk_user, pk_service, token, setToken } = useContext(StoreContext);

    const [resources, setResources] = useState([])
    const [showAlert, setShowAlert] = useState(false)
    const [alert, setAlert] = useState({header: '', message: '', type: '', options_btn: []});

    const navegation = [
        {
            'nome': 'home',
            'link': '/'
        },
        {
            'nome': 'integration layer',
            'link': `/integration-layer?service_id=${pk_service}`
        }
    ]

    useEffect(() => {
        api.get('resources', {
            params: {'service_id': pk_service, 'pk_user': pk_user},
            headers: {'Authorization': token}
        }).then(response => {
            setResources(response.data);
        })
        .catch(error => {
            errorHandlerShow(error, setToken, setAlert, setShowAlert)
        })
    }, []);


    return (
        <div className="main-mf-container">
            <div className="main-mf-content">
                <AlertCustom showAlert={showAlert} setShowAlert={setShowAlert} alert={alert} />

                {/* Barra de navegação */}
                <NavigationBar navegation={navegation} />

                {/* Objetivo */}
                <div>
                    <h1 className="main-mf-title">Objetivo</h1>
                    <p className="main-mf-p">A plataforma integradora é responsável por centralizar as extrações de dados de ambientes internos e externa da Natura & CO.
                        <br /><br />
                        Tem o objetivo de:
                        <br /><br />
                        1) Evitar extrações de dados de diferentes tipos de sistemas/tecnologias na mesma origem;
                        <br /><br />
                        2) Padronizar a disponibilização dos dados para sistemas internos da Natura & CO;
                        <br /><br />
                        3) Garantir controle de entrada e saída de dados respeitando padrões;
                        <br /><br />
                        4) Aplicação de qualidade de dados;
                        <br /><br />
                        5) Governar o dado desde a integração com a origem até a disponibilização;
                        <br /><br />
                        6) Centralização dos metadados para aplicações analíticas;
                    </p>
                </div>

                {/* Contexto */}
                <div>
                    <h1 className="main-mf-title">Contexto</h1>
                    <p className="main-mf-p">
                        A plataforma integradora definirá uma série de adapters, responsável por conectar em um tipo específico de tecnologias, exemplo: RDBMS, files system, object storage. Respeitando a característica natural do dado quente (near-real time), morno (intraday) e frio (batch).
                    <br /><br />
                        Entendemos com escopo do consumo do dado na plataforma, sistemas que necessitam de uma extração raw data a partir da origem. Será considerado fora do escopo aplicações que necessitam do dado para uso.
                    </p>
                </div>

                 {/* Desenho do processo */}
                 <div>
                    <h1 className="main-mf-title">Desenho do processo</h1>
                    <img className="main-mf-process-design" src={image_default} />
                </div>

                {/* Precisa de ajuda? */}
                <div>
                    <h1 className="main-mf-title">Precisa de ajuda?</h1>
                    <p className="main-mf-p">O icone de ajuda, presente na barra superior do lado direito, possui informações úteis durante o cadastro de arquivos/bases na integration layer. Se ainda assim persistirem dúvidas, entrar em contato com o time de engenharia de dados.</p>
                </div>

                < br />

                {/* Funções habilitadas */}
                <div>
                    <p className="main-mf-title">Funções habilitadas</p>
                    <div className="main-mf-container-functions">
                        {resources.length <= 0 ?
                            [0, 1, 2].map(()=>(
                                <SmallCardPlaceholder />
                            ))
                        :
                            resources.map((item, index) => (
                                <SmallCard key={index} title={item.type_resource} color={item.color_hex} image={item.image_name} url={item.link_resource} />
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default IntegrationLayerHome;
